import { useState } from "react";
import { Play } from "lucide-react";
import { HERO_IMAGE } from "@/lib/data";

/**
 * No header — sits directly under hero per user request.
 * Accepts optional embedUrl prop later. For now, displays a styled placeholder.
 */
export default function AboutVideo({ embedUrl }) {
    const [playing, setPlaying] = useState(false);

    return (
        <section
            data-testid="about-video-section"
            className="relative bg-[#1A1A1A] text-[#F7F5F0]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
                <div className="aspect-video w-full relative overflow-hidden border border-[#2a2a2a] grain">
                    {playing && embedUrl ? (
                        <iframe
                            src={embedUrl}
                            title="Vickie Daignault — A Quick Hello"
                            className="absolute inset-0 w-full h-full"
                            allow="autoplay; fullscreen"
                            allowFullScreen
                        />
                    ) : (
                        <button
                            onClick={() => embedUrl && setPlaying(true)}
                            data-testid="about-video-play"
                            className="group absolute inset-0 w-full h-full"
                            aria-label="Play introduction video"
                        >
                            <img
                                src={HERO_IMAGE}
                                alt=""
                                className="w-full h-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-500"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
                                <span className="w-16 h-16 md:w-20 md:h-20 rounded-full border border-[#F7F5F0]/70 flex items-center justify-center group-hover:border-[#C67C4E] group-hover:scale-110 transition-all duration-500">
                                    <Play
                                        size={22}
                                        className="text-[#F7F5F0] ml-1"
                                        fill="currentColor"
                                    />
                                </span>
                                <span className="eyebrow text-[#F7F5F0]/80">
                                    A Quick Hello
                                </span>
                                {!embedUrl && (
                                    <span className="text-xs text-[#F7F5F0]/40 tracking-wider mt-2">
                                        Video coming soon
                                    </span>
                                )}
                            </div>
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
}
